module.exports = __webpack_public_path__ + "img/par_q_form.24cff27b.png";